let sanKeyEggData = [
    {type:1,source: '祖代种鸡',target: '父母代种鸡',value: 20},
    {type:1,source: '父母代种鸡',target: '种蛋',value: 20},
    {type:1,source: '种蛋',target: '鸡苗',value: 20},
    {type:2,source: '鸡苗',target: '商品代蛋鸡',value: 20},
    {type:2,source: '商品代蛋鸡',target: '鸡蛋',value: 10},
    {type:3,source: '鸡蛋',target: '直接食用',value: 10},
    {type:3,source: '鸡蛋',target: '食品厂加工',value: 10},
    {type:3,source: '商品代蛋鸡',target: '淘汰鸡',value: 10},
    {type:3,source: '淘汰鸡',target: '农贸市场',value: 10},
    {type:3,source: '淘汰鸡',target: '屠宰场',value: 10},
]

let sanKeyFeedData = [
    {type:1,source: '进口大豆(转基因)',target: '转基因豆粕',value: 78},
    {type:2,source: '转基因豆粕',target: '猪料',value: 43},
    {type:2,source: '转基因豆粕',target: '禽料',value: 51},
    {type:2,source: '转基因豆粕',target: '水产料',value: 4},
    {type:2,source: '转基因豆粕',target: '其他',value: 2},
    {type:1,source: '进口大豆(转基因)',target: '豆油',value: 22},
    {type:2,source: '豆油',target: '食用',value: 89},
    {type:2,source: '豆油',target: '工业用',value: 11},
]

let sanKeyChickenData = [
    {type:1,source: '原代种鸡',target: '曾祖代种鸡',value: 20},
    {type:2,source: '曾祖代种鸡',target: '祖代种鸡',value: 20},
    {type:3,source: '祖代种鸡',target: '父母代种鸡',value: 20},
    {type:4,source: '父母代种鸡',target: '商品代种鸡',value: 20},
    {type:5,source: '商品代种鸡',target: '肉鸡产品',value: 20},

    {type:3,source: '培育期-24周',target: '产蛋期-41周',value: 20},
    {type:7,source: '产蛋期-41周',target: '淘汰',value: 20},
    {type:3,source: '产蛋期-41周',target: '孵化期-3周',value: 20},
    {type:4,source: '孵化期-3周',target: '培育期24周',value: 20},
    {type:5,source: '培育期24周',target: '产蛋期41周',value: 20},
    {type:3,source: '培育期24周',target: '孵化期3周',value: 20},
    {type:4,source: '孵化期3周',target: '培育期6周',value: 20},
    {type:4,source: '培育期6周',target: '出栏',value: 20},
    {type:7,source: '产蛋期41周',target: '淘汰',value: 20},

]

let sanKeyPigData = [
    {type:0,source: '育种扩繁',target: '曾祖代种猪',value: 20},
    {type:1,source: '曾祖代种猪',target: '祖代种猪',value: 20},
    {type:2,source: '祖代种猪',target: '父母代种猪',value: 20},
    {type:3,source: '父母代种猪',target: '商品代种猪',value: 20},
    {type:4,source: '商品代种猪',target: '肥猪出栏',value: 20},
    {type:5,source: '肥猪出栏',target: '屠宰企业加工',value: 20},

    {type:0,source: '自繁自养',target: '二元母猪',value: 20},
    {type:1,source: '二元母猪',target: '仔猪',value: 20},
    {type:2,source: '仔猪',target: '生猪',value: 20},
    {type:3,source: '生猪',target: '白条猪肉',value: 20},

    {type:0,source: '仔猪育肥',target: '仔猪 ',value: 20},
    {type:1,source: '仔猪 ',target: '生猪 ',value: 20},
    {type:2,source: '生猪 ',target: '白条猪肉',value: 20},


]

export {
    sanKeyEggData,
    sanKeyFeedData,
    sanKeyChickenData,
    sanKeyPigData
  }